import axios from 'axios';
import Vue from "vue";
import {baseURL} from '@/config/baseURL.js'
let vm = new Vue();
axios.defaults.baseURL = process.env.BASE_API;

const service = axios.create({
  timeout: 40000,
  headers: { 
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json; charset=UTF-8'
  },
  // baseURL: "http://192.168.0.176:9001",// vm.uploadUrl
  baseURL,// vm.uploadUrl
})
service.interceptors.request.use(
  config => {
  // console.log( vm.uploadUrl);
  return config
  },
  error => {
    Prom
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    return res
  },
)
export default service
